import { Pipe, PipeTransform } from '@angular/core';
import it from "src/app/translate/it-IT.json";
import en from "src/app/translate/en-US.json";
import { LangEnum } from '../models/LangEnum';
@Pipe({
  name: 'translate',
  pure: false
})
export class Translate implements PipeTransform {
  // private static locale: string;

  transform(value: string, ...args: unknown[]): unknown {
    // console.log(it);
    // console.log(en);
    let lang = this.getLocale();
    switch (lang) {
      case  LangEnum.IT:
        return it[value] ? it[value] : value;
      case LangEnum.EN:
        return en[value] ? en[value] : value;
      default:
        return value;
    }
  }
  getLocale() {

    return localStorage.getItem('lang');
  }
  setLocale(loc) {
    localStorage.setItem('lang', loc);
    // Translate.locale = loc;
  }
}
